itsoftApp.createModule("killLizard", function () {
    const module = this;

    const KillLizard = function () {
        this.lizzard = document.querySelector('.js-lizard');
        this.killer = document.querySelector('.js-lizard-killer');
        this.disclaimer = document.querySelector('.js-disclaimer');
        this.media = window.matchMedia('(min-width: 768px)');
        this.rotateDelta = 0.2;
        this.transformDelta = 2;
        this.curTransform = 0;
        this.curRotate = 0;
        this.oldScrollY = 0;
        this.safetyIndent = 0;
        this.lizzardBottom = 0;
        this.point = 0;
        this.entered = false;
        this.inited = false;

        if (this.lizzard) {
            this.init();
        }
    };

    KillLizard.prototype.getProps = function() {
        if (this.point > 0 && (window.scrollY > this.oldScrollY)) {
            this.entered = true;
            if (this.curRotate > 10) {
                return;
            }
            this.curTransform = this.curTransform + this.transformDelta;
            this.curRotate = this.curRotate + this.rotateDelta;
        } else if (this.entered) {
            if (this.curRotate < -5) {
                return;
            }
            this.curTransform = this.curTransform - this.transformDelta;
            this.curRotate = this.curRotate - this.rotateDelta;
        }
    }

    KillLizard.prototype.setProps = function() {
        this.killer.style.transform = `rotate(${this.curRotate}deg) translateX(${this.curTransform}px)`;
    }

    KillLizard.prototype.onScroll = function () {
        this.lizzardBottom = this.lizzard.getBoundingClientRect().bottom;
        this.safetyIndent = this.disclaimer.classList.contains('js-inactive') ? 0 : this.disclaimer.clientHeight;
        this.point = document.documentElement.clientHeight - this.lizzardBottom - this.safetyIndent;

        this.getProps();
        this.setProps();

        this.oldScrollY = window.scrollY;
    };

    KillLizard.prototype.onResize = function () {
        if (this.media.matches && !this.inited) {
            this.inited = true;
            document.addEventListener('scroll', this.onScroll);
        } else if (this.inited) {
            this.inited = false;
            document.removeEventListener('scroll', this.onScroll);
        }
    }

    KillLizard.prototype.init = function () {
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        this.media.addEventListener('change', this.onResize);
        this.onResize();
    };

    new KillLizard();
    module.callback = KillLizard;
});
